import { computed, getCurrentInstance } from 'vue';

export const useRoute = () => {
  try {
    const vm = getCurrentInstance()?.proxy;
    return computed(() => vm.$route);
  } catch (error) {
    console.error('No instance', error);
  }
};
